export const MinPortfolioSize = 0;
export const MaxPortfolioSize = 99999999.99;
export const MaxTotalInvestmentSelected = 50;
export const RemainingSpecialValue = "-0.00";
export const MaxWeight = 99999.99;

export class SmaPortfolioSetupConfigs {
  static readonly DefaultDecimalPlaces = 2;
  static readonly MinValueToSave = 0.01;
  static readonly MaxInvestmentsSelected = 50;
  static readonly MinPortfolioSize = 0;
  static readonly MaxPortfolioSize = 99999999.99;

  static readonly ZeroDecimalOverflowTooltip = "0.00000...";
}
